import * as S from './Tag.styled'

export const Tag = ({ children }) => {
  return <S.Tag>{children}</S.Tag>
}

export default Tag
